var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container", staticStyle: { width: "60%" } },
    [
      _c(
        "div",
        {
          staticStyle: {
            "margin-top": "20px",
            "margin-bottom": "20px",
            float: "right"
          }
        },
        [
          _c(
            "button",
            {
              staticStyle: { background: "none", border: "none" },
              attrs: { type: "submit", tag: "a" },
              on: { click: _vm.submit }
            },
            [
              _c("div", { staticClass: "btn btn-create" }, [
                _vm._v("\n        Submit Provider\n      ")
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("h4", [_vm._v("Provider Details")]),
      _vm._v(" "),
      _c("display"),
      _vm._v(" "),
      _c("div", { staticStyle: { "margin-top": "50px", float: "right" } }, [
        _c(
          "button",
          {
            staticStyle: { background: "none", border: "none" },
            attrs: { type: "submit", tag: "a" },
            on: { click: _vm.submit }
          },
          [
            _c("div", { staticClass: "btn btn-create" }, [
              _vm._v("\n        Submit Provider\n      ")
            ])
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-58ffdd57", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58ffdd57","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/submitPage.vue
// module id = 171
// module chunks = 0